import { updateGroupDoc } from '@db/Groups/Update';
import { uploadGroupPhoto } from '@db/Photos';
import { logError } from '@helpers/Loggers';
import db, { addDocWithTimestamps } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Photo } from '@types';
import { GroupFormData } from '@types';

export async function addGroup(
  {
    displayName,
    description,
    adminIds,
  }: Pick<GroupFormData, 'displayName' | 'description' | 'adminIds'>,
  photo?: Photo
) {
  const uniqueAdminIds = [...new Set(adminIds)];
  const groupId = await addGroupDoc({
    displayName,
    description,
    adminIds: uniqueAdminIds,
    photoUrl: '',
  });
  try {
    if (photo) {
      const uploadedPhoto = await uploadGroupPhoto(groupId, photo);
      await updateGroupDoc(groupId, {
        photoUrl: uploadedPhoto.uri,
      });
    }
  } catch (error) {
    logError(error);
  }
  return groupId;
}

export async function addGroupDoc(data: GroupFormData): Promise<string> {
  const docRef = await addDocWithTimestamps(db.collection(firestore, 'groups'), data);
  return docRef.id;
}
